/**
 * @param {Array<{ code?: string; value?: string | null }> | undefined} configurationOptions
 * @param {string} code
 * @returns {string}
 */
export function getTenantConfigurationOptionValue(configurationOptions, code) {
  const row = configurationOptions?.find(item => item?.code === code)
  return row?.value?.trim() ?? ''
}
